export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categoryName: string;
  imageUrl: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '赤裸特工第一季完整剧情回顾：从菜鸟到精英的蜕变之路',
    summary: '跟随主角林的脚步，回顾第一季中从一名普通警校毕业生到潜入国际犯罪组织的卧底特工，经历生死考验与人性挣扎的震撼旅程。',
    content: `<p>赤裸特工第一季以一场惊心动魄的银行劫案拉开序幕。主角林（由实力派演员张凯饰演）刚从警校毕业，在一次例行巡逻中意外卷入了一场精心策划的银行抢劫案。在这场案件中，林展现出了超乎寻常的观察力和应变能力，引起了国家安全部门特工招募官陈的注意。</p>

<p>经过严苛的选拔和训练，林被吸纳进入一个名为"暗影"的秘密特工组织。在这里，他遇到了日后的搭档——经验丰富的女特工苏婉。苏婉冷峻的外表下隐藏着一段不为人知的过往，而这也成为贯穿整个第一季的重要悬念。</p>

<p>第一季的核心任务是潜入一个名为"红蝎"的国际军火走私集团。林以假身份接近集团核心成员，在步步惊心的卧底行动中，他不仅要应对来自敌人的致命威胁，还要时刻警惕自己身份的暴露。最令人印象深刻的是第七集，林在集团内部的测试中险些暴露，凭借机智的临场反应才化险为夷，那一幕至今被观众津津乐道。</p>

<p>季终的高潮戏发生在公海的一艘豪华游轮上。林和苏婉联手阻止了一笔价值数十亿的军火交易，但也付出了惨痛的代价——苏婉为保护林而中弹落海，生死未卜。这个悬念十足的结局让无数观众翘首以盼第二季的到来。</p>

<p>第一季不仅在动作场面上令人叹为观止——从香港街头的追逐战到曼谷夜市的近身搏斗，每一场打戏都经过精心设计——更重要的是它深入探讨了卧底特工面临的身份认同危机和道德困境。当林开始对集团中某个成员产生真实的情感连接时，任务与人性之间的界限变得模糊，这也是赤裸特工区别于一般动作剧的核心魅力所在。</p>`,
    category: 'plot',
    categoryName: '剧情介绍',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20spy%20thriller%20scene%20with%20mysterious%20agent%20standing%20in%20dramatic%20shadow%20lighting%2C%20urban%20night%20background%20with%20neon%20reflections%2C%20film%20noir%20aesthetic%2C%20intense%20atmosphere%2C%20high%20contrast%20photography%2C%20moody%20and%20suspenseful%20composition&width=800&height=400&seq=article-plot-1&orientation=landscape',
    date: '2026-07-28',
    readTime: '8 分钟',
    tags: ['第一季', '剧情回顾', '林', '苏婉', '卧底'],
    featured: true,
  },
  {
    id: 'article-2',
    title: '张凯：从偶像到硬汉，赤裸特工让我重新定义了演员身份',
    summary: '主演张凯深度访谈，分享他为赤裸特工进行的魔鬼训练、角色理解，以及这部作品如何改变了他的演艺生涯。',
    content: `<p>在出演赤裸特工之前，张凯的名字更多与青春偶像剧联系在一起。然而当他接下这个角色时，所有人都没想到，这将是他演艺生涯最重要的转折点。</p>

<p>"接到剧本的时候，我连续读了三天三夜，根本停不下来。"张凯在采访中回忆道。"林的这个角色太有层次了——他不是一个完美的英雄，他有恐惧、有犹豫、有私心，但正是这些人性的弱点让他变得真实。"</p>

<p>为了塑造一个令人信服的特工形象，张凯在开拍前进行了长达六个月的魔鬼训练。每天清晨五点起床，先是两小时的体能训练，然后是格斗技巧、枪械操作和战术动作的学习。他的教练是前特种部队成员，训练强度不亚于真正的军事训练。</p>

<p>"最难的其实是心理层面的准备。"张凯坦言。"扮演卧底特工意味着你要时刻保持那种紧张感，那种随时可能暴露的恐惧，那种在两个世界之间撕裂的痛苦。拍戏那段时间，我经常失眠，因为入戏太深。"</p>

<p>张凯的付出换来了观众和专业评论人的一致好评。著名影评人李墨在评论中写道："张凯的表演让人忘记了他在演戏，他让观众相信，他就是那个在黑暗中负重前行的特工。"</p>

<p>当被问及赤裸特工对他的意义时，张凯沉默了片刻："这部戏让我明白，真正的演员不应该被任何标签定义。我很庆幸遇到了林这个角色，也很庆幸自己没有辜负他。"</p>`,
    category: 'cast',
    categoryName: '演员阵容',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20determined%20Asian%20male%20actor%20in%20dramatic%20lighting%2C%20wearing%20a%20dark%20tactical%20outfit%2C%20intense%20gaze%2C%20cinematic%20photography%20style%2C%20moody%20background%20with%20warm%20amber%20tones%2C%20editorial%20quality%20portrait&width=800&height=400&seq=article-cast-1&orientation=landscape',
    date: '2026-07-25',
    readTime: '6 分钟',
    tags: ['张凯', '演员专访', '主角', '林'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '赤裸特工动作设计揭秘：每场打戏都是一部微电影',
    summary: '动作指导王刚带你走进赤裸特工的动作世界，了解那些令人窒息的打斗场面是如何从创意变为现实的。',
    content: `<p>如果你曾被赤裸特工中那些行云流水又拳拳到肉的打斗场面震撼，那么你一定要认识王刚——这位曾是香港动作电影黄金时代亲历者的动作指导。</p>

<p>"现在的观众看了太多动作片，要让他们感到新鲜，每一场打戏都必须有独特的创意点。"王刚在赤裸特工的动作设计会议室里对我们说。墙上贴满了分镜脚本和动作分解图，每一张都详细标注了演员的动作轨迹、摄影机的位置和运动路线。</p>

<p>以第一季第三集中那段被粉丝称为"教科书级"的厨房打斗为例。这场戏发生在曼谷唐人街的一家狭窄的后厨，林与两名杀手在不足十平米的空间内展开生死搏斗。王刚花了整整两周时间来设计这段仅三分钟的动作戏。</p>

<p>"厨房里的每一样东西都是武器——菜刀、平底锅、擀面杖、甚至一瓶鱼露。"王刚笑着说。"我们要让观众觉得，林不是在使用道具，而是在利用环境求生。这种真实感是赤裸特工动作设计的核心哲学。"</p>

<p>安全始终是第一位的。每场打戏在实拍前都要经过数十次的排练。替身演员先完成动作的设计和测试，然后主演在指导下逐步学习并亲自完成大部分动作。"张凯的进步非常快，到第一季后期，那些复杂的近身格斗他基本都能自己完成。这对演员来说是巨大的挑战，但效果也是无可替代的。"</p>

<p>对于第二季的动作场面，王刚透露将有更多突破。"我们正在设计一些之前从未在电视剧中见过的动作场景。只能说，观众可以期待一些真正震撼的东西。"</p>`,
    category: 'behind-scenes',
    categoryName: '幕后故事',
    imageUrl: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20set%20with%20action%20choreography%2C%20stunt%20coordinators%20working%20with%20actors%2C%20professional%20camera%20equipment%2C%20dramatic%20warm%20lighting%2C%20cinematic%20filmmaking%20atmosphere%2C%20industrial%20warehouse%20setting&width=800&height=400&seq=article-behind-1&orientation=landscape',
    date: '2026-07-22',
    readTime: '7 分钟',
    tags: ['动作设计', '幕后制作', '王刚', '拍摄花絮'],
    featured: true,
  },
  {
    id: 'article-4',
    title: '赤裸特工第二季播出时间确定！全新预告引爆期待',
    summary: '官方正式公布第二季播出日期，全新预告片同步释出。新角色、新阴谋、更刺激的特工冒险即将展开。',
    content: `<p>经过漫长的等待，赤裸特工第二季的播出时间终于尘埃落定。官方今日正式宣布，第二季将于2026年9月15日在各大平台同步首播。</p>

<p>与播出日期一同发布的还有一支时长两分三十秒的全新预告片。预告以苏婉的回归开场——第一季结尾落海的她奇迹生还，但似乎经历了某些改变。镜头快速切换中，观众可以看到更多新面孔加入，包括由知名演员刘洋饰演的神秘反派角色"幽灵"，以及由新晋实力派演员赵小曼饰演的国际刑警李娜。</p>

<p>"第二季的格局比第一季更大。"导演周明在新闻发布会上表示。"故事将从'红蝎'集团延伸到更大的国际阴谋，林和苏婉将面临前所未有的挑战。我们去了更多国家和地区取景，动作场面和视觉体验都会有质的飞跃。"</p>

<p>预告中最引人注目的几个场景包括：迪拜沙漠中的追车戏、东京新宿的雨夜枪战，以及一个据称耗资千万搭建的地下基地场景。这些画面不仅展现了制作规模的升级，更暗示了剧情将向更宏大的方向发展。</p>

<p>第二季共12集，每集60分钟，每周五更新两集。平台方表示，考虑到全球观众的强烈需求，第二季将同步提供中英双语字幕，覆盖超过150个国家和地区。</p>

<p>粉丝们已经在社交媒体上炸开了锅。话题#赤裸特工第二季#在发布后一小时内就登上了热搜榜首位，相关讨论量突破千万。一位资深剧迷在评论区写道："等了一年多终于等到了！预告片每一帧都想截图！"</p>`,
    category: 'news',
    categoryName: '最新资讯',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20promotional%20poster%20for%20a%20spy%20thriller%20series%2C%20silhouettes%20against%20a%20golden%20sunset%20sky%2C%20urban%20skyline%20background%2C%20cinematic%20composition%20with%20intense%20atmosphere%2C%20professional%20movie%20poster%20aesthetic&width=800&height=400&seq=article-news-1&orientation=landscape',
    date: '2026-08-01',
    readTime: '5 分钟',
    tags: ['第二季', '播出时间', '预告片', '新角色'],
    featured: true,
  },
  {
    id: 'article-5',
    title: '赤裸特工中那些令人拍案叫绝的反转：你猜到了吗？',
    summary: '盘点赤裸特工第一季中最令人震惊的十大剧情反转，每一个都颠覆了观众的预期，展现了编剧的高超功力。',
    content: `<p>赤裸特工之所以能在众多间谍剧中脱颖而出，很大程度上归功于其出人意料的剧情设计。今天我们就来盘点第一季中那些让观众惊呼"怎么可能"的十大反转时刻。</p>

<p><strong>反转一：招募官陈的真实身份</strong><br/>当林以为陈只是一名普通的特工招募官时，谁也没想到他竟然是"暗影"组织的最高负责人之一。这个身份直到第六集才揭晓，而陈在第一集中那句看似随意的"我会一直看着你"竟成了最意味深长的伏笔。</p>

<p><strong>反转二：苏婉的弟弟</strong><br/>第七集中，苏婉在任务中突然失控，原因竟是她发现了失踪多年的弟弟竟然成为了"红蝎"集团的核心成员。这一发现不仅让任务陷入危机，也为苏婉的角色增添了更深的情感层次。</p>

<p><strong>反转三：看似盟友的背叛</strong><br/>第九集中，林在警局内部的线人——一位看似友善的老警察——原来一直在向"红蝎"通风报信。这个角色在前八集中被塑造成一个温和无害的长者形象，其叛变令观众大感意外。</p>`,
    category: 'reviews',
    categoryName: '剧评分析',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20dramatic%20scene%20with%20shadows%20and%20reflections%2C%20film%20noir%20style%2C%20suspenseful%20atmosphere%2C%20dark%20cinematic%20lighting%2C%20abstract%20composition%20suggesting%20conspiracy%20and%20intrigue&width=800&height=400&seq=article-review-1&orientation=landscape',
    date: '2026-07-20',
    readTime: '10 分钟',
    tags: ['剧情反转', '深度分析', '第一季', '剧评'],
    featured: false,
  },
  {
    id: 'article-6',
    title: '赤裸特工在线观看全攻略：各平台对比与最佳选择',
    summary: '为你整理赤裸特工在各大平台的观看方式、画质对比、会员价格与独家内容，帮你找到最适合的追剧渠道。',
    content: `<p>随着赤裸特工第二季即将上线，很多观众都在问：到底哪个平台看效果最好？今天我们就来做一个全平台对比，帮你做出最优选择。</p>

<p><strong>主流视频平台</strong><br/>目前赤裸特工在以下平台均可观看：腾讯视频、爱奇艺、优酷和B站。四个平台均提供4K超高清画质，但具体体验存在差异。</p>

<p><strong>画质对比</strong><br/>经过实际测试，腾讯视频和爱奇艺的4K HDR效果最佳，尤其是在暗光场景的表现上更为出色——这对于以夜景和暗色调为主的赤裸特工来说尤为重要。优酷的杜比全景声支持则让枪战和追车场景的沉浸感更强。</p>

<p><strong>会员价格</strong><br/>腾讯视频VIP月卡25元，爱奇艺黄金VIP月卡22元，优酷VIP月卡20元，B站大会员月卡25元。建议选择年卡方案，各平台都有不同程度的优惠。</p>

<p><strong>独家内容</strong><br/>B站拥有赤裸特工的独家幕后纪录片，包括演员训练日记和动作设计花絮；腾讯视频则上线了主创访谈特别节目。</p>

<p><strong>最佳推荐</strong><br/>如果只选一个平台，推荐腾讯视频，综合画质、价格和独家内容来看性价比最高。</p>`,
    category: 'watch-guide',
    categoryName: '观看指南',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20entertainment%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20cozy%20home%20theater%20ambiance%2C%20warm%20ambient%20lighting%2C%20comfortable%20viewing%20environment%2C%20clean%20minimalist%20interior%20design&width=800&height=400&seq=article-watch-1&orientation=landscape',
    date: '2026-07-18',
    readTime: '5 分钟',
    tags: ['观看指南', '平台对比', '在线观看', '4K画质'],
    featured: false,
  },
  {
    id: 'article-7',
    title: '赤裸特工取景地巡礼：跟随镜头走遍世界',
    summary: '从香港的霓虹街道到曼谷的隐秘庙宇，从东京的摩天大楼到迪拜的沙漠腹地，带你走进赤裸特工的拍摄现场。',
    content: `<p>赤裸特工被誉为"旅行宣传片级别的电视剧"，其取景地涵盖了亚洲多个国家和地区。今天，让我们跟随摄影机的脚步，一起探访这些令人心驰神往的拍摄地点。</p>

<p><strong>香港：故事的起点</strong><br/>第一季的开篇在香港取景。旺角的霓虹灯牌、中环的摩天大楼、深水埗的老街巷，都在镜头中呈现出了独特的质感。尤其是第三集中林在庙街夜市的追逐戏，完美捕捉了香港最具烟火气的一面。</p>

<p><strong>曼谷：卧底行动的舞台</strong><br/>曼谷是赤裸特工最重要的海外取景地之一。剧组在曼谷拍摄了近两个月，取景地点包括考山路、郑王庙和安帕瓦水上市场。第七集中那段令人窒息的河上追逐战就是在安帕瓦拍摄的。</p>

<p><strong>东京：未来感与前卫美学</strong><br/>第二季新增了东京取景。预告中闪现的新宿雨夜枪战场景，取景于歌舞伎町。东京的取景为赤裸特工注入了全新的视觉风格——冷调的霓虹灯光、极具未来感的建筑线条。</p>

<p><strong>迪拜：沙漠中的奢华与危险</strong><br/>第二季的重头戏在迪拜的沙漠中展开。剧组在利瓦沙漠搭建了一个临时拍摄基地，追车戏动用了超过二十辆改装车辆。</p>`,
    category: 'behind-scenes',
    categoryName: '幕后故事',
    imageUrl: 'https://readdy.ai/api/search-image?query=Travel%20photography%20collage%20featuring%20iconic%20Asian%20cityscapes%2C%20Hong%20Kong%20neon%20streets%2C%20Bangkok%20temples%2C%20Tokyo%20urban%20night%20scenes%2C%20cinematic%20travel%20aesthetic%2C%20warm%20atmospheric%20tones&width=800&height=400&seq=article-behind-2&orientation=landscape',
    date: '2026-07-15',
    readTime: '8 分钟',
    tags: ['取景地', '香港', '曼谷', '东京', '迪拜', '拍摄花絮'],
    featured: false,
  },
  {
    id: 'article-8',
    title: '赤裸特工为什么能成为现象级作品？深度解析五大成功因素',
    summary: '从剧本到制作，从演员到营销，全方位分析赤裸特工成功的背后原因，探讨其对国产间谍剧的启示意义。',
    content: `<p>赤裸特工自播出以来，不仅收视率节节攀升，更在社交媒体上引发了持续性的讨论热潮。那么，是什么让这部作品成为了现象级的文化事件？我们从五个维度进行深入分析。</p>

<p><strong>一、剧本：类型融合的创新</strong><br/>赤裸特工最大的突破在于打破了传统谍战剧的固有模式。它将动作片的视觉冲击力、悬疑片的紧张节奏和人物剧的情感深度有机融合。</p>

<p><strong>二、制作：电影级的品质追求</strong><br/>赤裸特工的制作标准远超一般电视剧，很多时候更像是12部迷你电影的组合。每集的制作周期长达三周，远超行业平均水平。</p>

<p><strong>三、演员：角色与演员的完美契合</strong><br/>选角的成功是赤裸特工的另一大法宝。张凯从偶像转型硬汉的过程本身就是一部励志故事。</p>

<p><strong>四、现实主义：在虚构中寻找真实</strong><br/>尽管剧情充满戏剧性，但赤裸特工始终保持着对现实议题的关注——卧底特工的心理创伤、国家安全与个人权利的平衡。</p>

<p><strong>五、观众互动：社交媒体的裂变传播</strong><br/>赤裸特工充分利用了社交媒体的传播力量，每集的悬念设置都经过精心设计以激发观众讨论。</p>`,
    category: 'reviews',
    categoryName: '剧评分析',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20conceptual%20art%20representing%20success%20and%20achievement%2C%20modern%20minimalist%20design%2C%20warm%20golden%20and%20amber%20tones%2C%20sophisticated%20artistic%20composition%2C%20elegant%20visual%20metaphor&width=800&height=400&seq=article-review-2&orientation=landscape',
    date: '2026-07-12',
    readTime: '9 分钟',
    tags: ['深度分析', '成功因素', '行业影响', '剧评'],
    featured: false,
  },
  {
    id: 'article-9',
    title: '赤裸特工服装造型全解密：每个角色的穿搭都是一部暗号',
    summary: '造型师透露，赤裸特工中每个角色的服装都蕴含着关于其身份、性格和命运的重要线索。',
    content: `<p>在赤裸特工中，服装不仅仅是视觉元素，更是叙事工具。造型指导孙莉在专访中为我们解密了角色服装背后的设计哲学。</p>

<p>"给特工设计服装是最有趣的挑战，"孙莉说，"因为他们的衣服需要在美观、实用和隐蔽性之间找到完美平衡。每一件衣服都有它的功能性考量——口袋的位置、面料的耐磨度、颜色的隐蔽性。"</p>

<p>林的角色服装演变是整部剧中最完整的视觉叙事线。第一集他穿着普通的T恤和牛仔裤，体现了菜鸟的身份；随着剧情的推进，他的服装逐渐变得更加精致和战术化。</p>

<p>苏婉的造型则以冷色调为主，强调了她外冷内热的性格特点。她的标志性皮夹克是专门定制的——外观时尚但内衬使用了防割材料。</p>`,
    category: 'behind-scenes',
    categoryName: '幕后故事',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20design%20studio%20with%20costume%20sketches%20and%20fabric%20swatches%2C%20cinematic%20wardrobe%20styling%2C%20professional%20costume%20design%20atmosphere%2C%20warm%20studio%20lighting%2C%20creative%20fashion%20workspace&width=800&height=400&seq=article-behind-3&orientation=landscape',
    date: '2026-07-10',
    readTime: '6 分钟',
    tags: ['服装造型', '幕后制作', '角色设计', '孙莉'],
    featured: false,
  },
  {
    id: 'article-10',
    title: '从赤裸特工看当代间谍剧的叙事革新',
    summary: '赤裸特工的出现标志着国产间谍剧进入全新阶段。本文从叙事学角度分析其创新之处与行业意义。',
    content: `<p>赤裸特工的出现，不仅是商业上的成功，更代表了国产间谍剧在叙事层面的一次重要革新。</p>

<p><strong>非线性叙事的成熟运用</strong><br/>赤裸特工大胆采用了非线性叙事结构，频繁在现在和过去之间切换。这种手法在电影中并不罕见，但在长篇电视剧中保持连贯性是一个巨大的挑战。</p>

<p><strong>道德灰色地带的探索</strong><br/>传统国产谍战剧通常有明确的好坏之分，但赤裸特工打破了这种二元对立。剧中没有一个角色是纯粹的好人或坏人。</p>

<p><strong>全球化视野的本土表达</strong><br/>赤裸特工的故事虽然发生在国际背景下，但其精神内核是中国的。这种"用世界语言讲中国故事"的做法值得借鉴。</p>`,
    category: 'reviews',
    categoryName: '剧评分析',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intellectual%20analysis%20concept%2C%20open%20books%20and%20film%20reels%20in%20artistic%20arrangement%2C%20warm%20library%20atmosphere%2C%20sophisticated%20academic%20aesthetic%2C%20golden%20hour%20lighting%20through%20windows&width=800&height=400&seq=article-review-3&orientation=landscape',
    date: '2026-07-08',
    readTime: '7 分钟',
    tags: ['叙事革新', '行业分析', '深度评论', '间谍剧'],
    featured: false,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getRelatedArticles = (article: Article, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, count);
};